import { QuickstartActionPage } from './QuickstartActionPage';
import { QuickstartTheme } from '../types/theme';
import { buildQuickstartSteamUrl } from '../utils/steamUrls';

interface QuickstartCTAProps {
  theme: QuickstartTheme;
  exitReason?: 'afk_timeout' | 'ad_timer_expired' | 'wishlist_clicked' | 'manual_exit' | 'invitation_invalidated';
  onWishlistCTAClicked: () => void;
}

export const QuickstartCTA = ({ theme, exitReason, onWishlistCTAClicked }: QuickstartCTAProps) => {
  const getMessage = () => {
    switch (exitReason) {
      case 'afk_timeout':
        return 'Your session timed out due to inactivity';
      case 'ad_timer_expired':
        return 'Thanks for playing the demo!';
      case 'wishlist_clicked':
        return 'Thanks for your interest!';
      case 'invitation_invalidated':
        return 'Thanks for playing the demo!';
      default:
        return 'Thanks for playing!';
    }
  };

  const handleButtonClick = () => {
    onWishlistCTAClicked();

    // Open in new tab instead of redirecting (prevents canceling analytics request)
    // Works on both mobile and desktop
    if (theme.steamUrl) {
      const steamUrlWithUtms = buildQuickstartSteamUrl(theme.steamUrl);
      window.open(steamUrlWithUtms, '_blank', 'noopener,noreferrer');
    }
  };

  // Console log the message for now
  console.log('[QuickstartCTA] Message:', getMessage());

  return <QuickstartActionPage theme={theme} onButtonClick={handleButtonClick} />;
};

